import React, { useRef, useState, useEffect } from 'react';
import _ from 'lodash';

import { styled } from '@mui/material/styles';

import Table from './table';
import { Paper, Button, useTheme, useMediaQuery } from '@mui/material';
import DoneOutlineIcon from '@mui/icons-material/DoneOutline';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useSwipeable } from "react-swipeable";


const PREFIX = 'Activities';

const classes = {
    paper: `${PREFIX}-paper`,
    topbar: `${PREFIX}-topbar`,
    new_lesson: `${PREFIX}-new_lesson`,
    new_lesson_button: `${PREFIX}-new_lesson_button`,
    searchbar: `${PREFIX}-searchbar`,
    multicheckboxFilter: `${PREFIX}-multicheckboxFilter`,
    filterSummary: `${PREFIX}-filterSummary`,
    stage_options: `${PREFIX}-stage_options`
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')((
    {
        theme
    }
) => ({
    [`& .${classes.paper}`]: {
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'hidden',
        overflowX: 'hidden',
        height: '100%',
    },

    [`& .${classes.topbar}`]: {
        display: 'flex',
        padding: '1rem',
        paddingBottom: '0rem',
    },

    [`& .${classes.new_lesson}`]: {
        padding: '0.5rem',
    },

    [`& .${classes.new_lesson_button}`]: {
        backgroundColor: '#0B7CB0',
        color: 'white',
        minWidth: '20vw',
        height: '2.5rem',
    },

    [`& .${classes.searchbar}`]: {
        display: 'inline-flex',
        alignItems: 'flex-end'
    },

    [`& .${classes.multicheckboxFilter}`]: {
      width: '200px',
      paddingBottom: '1rem',
      display: 'inline-block',
    },

    [`& .${classes.filterSummary}`]: {
      maxWidth: '60vw'  
      },

    [`& .${classes.stage_options}`]: {
      '&.MuiInputBase': {
        margin: '0px',
      },
      '&.MuiSelect-icon': {
        display: 'none',
      }
    }
}));

// Styles for the React Table
const Styles = styled('div')({
    '& .table': {
        display: 'flow-root',
        borderSpacing: 0,
        borderLeft: 0,
        fontFamily: 'Roboto',
        overflowX: 'auto',
        overflowY: 'auto',
        '& .tr:last-child .td': {
            borderBottom: '1px solid black',
        },
        '& .th': {
            textAlign: 'left',
            background: '#093d61',
            color: 'white',
            height: '2.5rem',
            padding: '0.5rem',
            borderBottom: '1px solid black',
            borderRight: '1px solid black',
        },
        '& .td': {
            position: 'relative',
            margin: 0,
            padding: '0.4rem',
            paddingLeft: 0,
            paddingRight: 0,
            borderLeft: '1px solid black',
            borderBottom: '1px solid #d1d5da',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            '& .resizer': {
                display: 'inline-block',
                width: 7,
                height: '100%',
                position: 'absolute',
                right: 0,
                top: 0,
                transform: 'translateX(50%)',
                zIndex: 1,
                touchAction: 'none',
            },
        },
    },
});

//Function that pulls the data and sends it to the Table Renderer
const Activities = props => {
    const theme = useTheme();
    let { activity_view_data, loading, showDetailedView, updateDetailView, toggleDetailView, wbs_level, updateLLViewSettings, collapsed_activities, selectedActivities, setSelectedActivities, selected_activity, updateMobileDisplayTab} = props;

    const tableInstance = useRef(null);
    const rem_value = Math.round(window.innerWidth)/100;

    const activities_column_width = useMediaQuery(theme.breakpoints.up('sm')) ? Math.round(window.innerWidth * 0.205) : Math.round(window.innerWidth * 1)
    var hiddenColumns = ['id','has_children', 'ancestry'];

    const handlers = useSwipeable({
        onSwiped: (eventData) => {
            if (eventData.dir==='Left') {
                updateMobileDisplayTab(1)                
            }
        }
    });


    let mode = 1;
    // Acitvities View: Mode 1 | New Lesson: Mode 2
    if (document.title == 'Lessons Learned') {
        mode = 1;
        hiddenColumns.push('selector')
    } else if (document.title == 'Log a Lesson') {
        mode = 2;
    }

    //DetailedView
    // if (showDetailedView) {
    //   hiddenColumns = ['id', 'selector', 'link_activity', 'ancestry', 'has_children'];  
    // }
    hiddenColumns = ['id', 'selector', 'link_activity', 'ancestry', 'has_children'];  

    // Data being fed to the table
    const [activityViewData, setActivityViewData] = useState(activity_view_data) 


    useEffect(() => {
        setActivityViewData(activity_view_data)
    },[activity_view_data])

    const columns = React.useMemo(() => [
        {
            Header: 'id',
            accessor: 'id',
            width: 5*rem_value,
        },
        {
            Header: 'Selector',
            accessor: 'selector',
            width: 6*rem_value,
            Cell: (props) => {
            const [value, setValue] = useState(selectedActivities.includes(parseInt(props.row.values.id)) ? 'selected' : 'select');
            
            return(
                <div 
                    onClick={() => {
                        let temp = [...activityViewData]

                        if (value !== 'selected') {
                            setSelectedActivities([...selectedActivities, parseInt(props.row.values.id)])
                            temp[props.row.index].selector = 'selected'
                        } else {
                            let temp2 = [...selectedActivities]
                            setSelectedActivities(temp2.filter(e => e !==parseInt(props.row.values.id)))                            
                            temp[props.row.index].selector = 'select'
                        }
                        setActivityViewData(temp);
                    }}
                >
                    <Button
                        variant={value === 'selected' ? 'contained' : 'outlined'}
                        style={{backgroundColor: value==='selected' ? '#22ba43' : '#FFFFFF', outline: '#2f2f2f solid 1px'}}
                    >
                        {value}
                    </Button>
                </div>
            )
            },
        },
      {
            Header: 'Ancestry',
            accessor: 'ancestry',
            width: 10*rem_value,
            Cell: (props) => {
              return(props.value)
            },
        },
        {
            Header: 'Has Children',
            accessor: 'has_children',
            width: 10*rem_value,
            Cell: (props) => {
              return(props.value)
            },
        },
        {
            Header: 'Activity',
            accessor: 'title',
            // width: Math.round(window.innerWidth * 0.22),
            width: activities_column_width,
            Cell: (props) => {
                let space = [];
                if (props.row.values.ancestry) {
                    space = props.row.values.ancestry.split(',');
                }
                return (
                    <div 
                        style={{display: 'flex', cursor: 'pointer'}}
                    >
                        {props.row.values.has_children ? 
                            collapsed_activities.includes(props.row.values.id) ? 
                                (<ArrowRightIcon onClick={() => updateLLViewSettings('activity_collapse', props.row.values.id)} />) 
                                : 
                                (<ArrowDropDownIcon onClick={() => updateLLViewSettings('activity_collapse', props.row.values.id)}/>) 
                            : 
                            <Root>&emsp;&ensp;</Root>
                        }
                        <div 
                            onClick={() => updateLLViewSettings('activity_select', String(props.row.values.id)+'<<>>'+props.value)}
                            style={{display: 'flex', alignItems: 'center', minWidth: '100%'}}
                        >
                        {space.map((e, i) =>
                            <React.Fragment key={i}>&ensp;</React.Fragment>
                        )}
                        {props.value}
                        <span style={{color: 'gray', fontSize: 'smaller'}}><i>&nbsp;{props.row.original.link_activity.length}</i></span>
                        {(props.row.values.id===selected_activity) && (
                            <>&emsp;<DoneOutlineIcon style={{padding: '0px'}} fontSize='small'/></>
                        )}
                        </div>
                    </div>
                );
            },
        }
    ]);

    return (
        <>
            {loading ? (
                <>
                </>
            ) : (
                <Paper 
                    // className={classes.paper} id='activity_view'
                    // style={{ minWidth: showDetailedView ? Math.round(window.innerWidth * 0.23) : Math.round(window.innerWidth * 0.8) }}
                    {...handlers}
                >
                    {/* <div className={classes.new_lesson}>
                        <Button 
                            variant="contained" 
                            className={classes.new_lesson_button} 
                            component={Link}
                            to={'/ll/new-lesson'}
                            // target='_blank'                        
                        >
                            New Lesson
                        </Button>
                    </div> */}

                    <Styles>
                        <Table 
                            columns={columns} 
                            data={activityViewData} 
                            ref={tableInstance} 
                            hiddenColumns={hiddenColumns}
                            updateLLViewSettings={updateLLViewSettings}
                            getCellProps={cellInfo => {
                                let columncheck = cellInfo.column.Header === "Activity" ? true : false;
                                let cellAncestryCount = cellInfo.row.values.ancestry != null ? cellInfo.row.values.ancestry.split(',').length : 0;
                                // let spectrum = ['#093D61', '#0B7CB0', '#29ABE2', '#00AEEF']
                                // let spectrum = ['#B1DAE7', '#c5e4ed', '#d8edf3', '#ECF6F9', '#FFFFFF']
                                let spectrum = ['#A9D0DD','#c5e4ed', '#d8edf3', '#ECF6F9', '#FFFFFF']
                                // let spectrum = ['#FFFFFF', '#FFFFFF', '#FFFFFF', '#FFFFFF']
                                let bgcolor = ''
                                let fontcolor = ''
                                if (columncheck) {
                                    bgcolor = spectrum[cellAncestryCount];
                                    // fontcolor = '#FFFFFF'
                                    fontcolor = '#000000'
                                }
                                return(
                                    {
                                        style: {
                                          backgroundColor: bgcolor,
                                          color: fontcolor
                                        },
                                      }
                                )
                            }}
                      
                        />
                    </Styles>
                </Paper>
            )}
        </>
    );
};

export default Activities;